import useAuth from "./useAuth";
import { mutate } from 'swr';
import config from "../config";

function useUsers() {
    const { data, error, isLoading } = useAuth();

    return {
        users: data?.data?.users,
        isLoading,
        isError: error,
    };
}

function useUser(userId) {
    const { users } = useUsers();

    if (users?.length >= 1) {
        const currentUser = users.find((u) => u._id === userId);
        return currentUser;
    }

    return undefined;
}

function createUser(auth, data) {
    console.log('create ->', { auth, data });
}

function deleteUser(auth, id) {
    for (let c = auth.users.length -1; c >= 0; c -= 1) {
        if (auth.users[c]._id === id) {
            auth.users.splice(c, 1);
        }
    }

    fetch(`${config.apiUrl}/company/${auth._id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(auth),
    }).then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        mutate('authData');
    }).then((data) => {
        // Process the data returned from the API
        console.log("PUT request successful:", data);
    }).catch((error) => {
        console.error("Error while making PUT request:", error);
    });
}

function logUserIn(data, callback) {
    fetch(`${config.apiUrl}/company`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => {
            callback(!!data.statusCode);
            mutate('authData');
        })
        .catch(error => {
            // Handle any errors that occurred during the fetch call
            console.error("Error:", error);
        })
}

function updateUser(auth, data) {
    auth.users.forEach((user, idx) => {
        if (user._id === data._id) {
            console.log({ user, data });
            auth.users[idx].firstName = data.firstName;
            auth.users[idx].lastName = data.lastName;
            auth.users[idx].email = data.email;
        }
    });

    fetch(`${config.apiUrl}/company/${auth._id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(auth),
    }).then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        mutate('authData');
    }).then((data) => {
        // Process the data returned from the API
        console.log("PUT request successful:", data);
    }).catch((error) => {
        console.error("Error while making PUT request:", error);
    });
}

export { useUsers, useUser, updateUser, deleteUser, createUser, logUserIn };
